import { DOCUMENT, Injectable, inject } from '@angular/core'

import { DragHandlerParams, MoveService, Position } from './drag.models'

const DEFAULT_PADDING: Position = { top: 0, right: 0, bottom: 0, left: 0 }

const DEFAULT_ANIMATION = '0.35s ease-in-out'

@Injectable({
  providedIn: 'root',
})
export class FreeMoveService implements MoveService {
  private document = inject<Document>(DOCUMENT)

  onDragMove({ element, toPosition: { x: toX, y: toY } }: DragHandlerParams): Position {
    const newPosition: Position = {}

    newPosition.left = toX
    newPosition.top = toY

    element.style.transition = null

    return newPosition
  }

  onDragEnd({
    element,
    toPosition,
    padding,
    animation = DEFAULT_ANIMATION,
  }: DragHandlerParams): Position {
    element.style.transition = animation

    return this.calculateElementNewPosition({ element, toPosition, padding })
  }

  calculateElementNewPosition({
    element,
    toPosition: { x: toX, y: toY },
    padding = DEFAULT_PADDING,
  }: DragHandlerParams): Position {
    const newPosition: Position = {}
    const { clientHeight: viewportHeight, clientWidth: viewportWidth } = this.document.body
    const { offsetHeight: elemHeight, offsetWidth: elemWidth } = element

    if (toX + elemWidth > viewportWidth) {
      newPosition.left = viewportWidth - elemWidth - padding.right
    } else if (toX < 0) {
      newPosition.left = padding.left
    } else {
      newPosition.left = toX
    }

    if (toY + elemHeight > viewportHeight) {
      newPosition.top = viewportHeight - elemHeight - padding.bottom
    } else if (toY < 0) {
      newPosition.top = padding.top
    } else {
      newPosition.top = toY
    }

    return newPosition
  }
}
